module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\" preserveAspectRatio=\"xMaxYMax meet\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M1 1l4 4 4-4\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/chevron.svg
// module id = sRcJ
// module chunks = 5